// Mock taxonomy of "Pessoas com deficiência" sub-types. Persisted by ID so the
// label can be re-localised by the BFF later without breaking selections.
// Until the recruiter BFF exposes the real catalogue this is the source of
// truth for the diversity > deficiência sub-modal.

export interface DisabilityOption {
  id: string;
  label: string;
  /** When true, the dialog shows a free-text input next to this option. */
  freeText?: boolean;
}

export const DISABILITY_OPTIONS: readonly DisabilityOption[] = [
  { id: 'auditiva', label: 'Deficiência Auditiva' },
  { id: 'fisica', label: 'Deficiência Física' },
  { id: 'intelectual', label: 'Deficiência Intelectual ou Cognitiva' },
  { id: 'visual', label: 'Deficiência Visual' },
  { id: 'multipla', label: 'Deficiência Múltipla' },
  { id: 'tea', label: 'Transtorno do Espectro Autista (TEA)' },
  { id: 'outra', label: 'Outra / especifique', freeText: true },
];

export const PROFICIENCY_LEVELS: readonly { id: string; label: string }[] = [
  { id: 'basico', label: 'Básico' },
  { id: 'intermediario', label: 'Intermediário' },
  { id: 'avancado', label: 'Avançado' },
];

/** Builds the "Pessoas com deficiência - Auditiva e Física" pill label. */
export function buildDisabilityPillLabel(
  selectedIds: readonly string[],
  otherText: string
): string {
  const labels = selectedIds.map((id) => {
    const option = DISABILITY_OPTIONS.find((entry) => entry.id === id);
    if (!option) return '';
    if (option.freeText) {
      return otherText.trim() || option.label;
    }
    // Strip the "Deficiência " prefix so the pill stays compact.
    return option.label.replace(/^Deficiência\s+/u, '');
  });
  return `Pessoas com deficiência - ${labels.filter(Boolean).join(' e ')}`;
}
